import { createDocument, getAllData } from "apis/customApiHandler";
import Spinner from "components/Spinner";
import { Fragment, useCallback, useEffect, useState } from "react";
import { BiCloudDownload } from "react-icons/bi";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import Modal from "components/Modal";
import { Input, Select } from "styled";
import { TD, TH } from "styled/table";
import exportExcel from "utils/exportExcel";
import {Button} from 'styled'
import getFormattedDate from "utils/helpers";
import axios from "axios";
import toast from "react-hot-toast";

let allMonths = [
  "",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];

const contractTypeOptions = [
  { value: 'All', label: 'All' },
  { value: 'CPKM', label: 'CPKM' },
  { value: 'NON CPKM', label: 'NON CPKM' }
];

const VehicleFleetReport = () => {
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [fleetMap, setFleetMap] = useState({});
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [reportData, setReportData] = useState("")
  const [downloading, setDownloading] = useState(false)
  const [enabled, setEnabled] = useState(false)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [contractType, setContractType] = useState("")
  const [showHubColumn, setShowHubColumn] = useState(false);

  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getDownloadData = async () => {
    setDownloading(true);
    try {
      const token = localStorage.getItem("token");
      const myPromise = axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}inspection/getQuarterInspections/download`,
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          ...(selectedHubs?.includes("all")
            ? {}
            : selectedHubs.length
            ? { hubs: selectedHubs.join(",") }
            : {}),

          ...(selectedFleets?.includes("all")
            ? {
                fleets: getFleetOptions()
                  .filter(
                    (item) => item.value !== "all" && item.value !== "clear"
                  )
                  .map((item) => item.value)
                  .join(","),
              }
            : selectedFleets.length
            ? { fleets: selectedFleets.join(",") }
            : {}),
          contractType,
          dateFrom,
          dateTo,
          reportName: "Vehicle Fleet Report",
        },
      });

      await toast.promise(
        myPromise,
        {
          loading: "Request Initiated, Please Hold on",
          success: (dt) => dt.data.message || "success",
          error: (err) =>
            err?.response?.data?.error ||
            err?.response?.data?.message ||
            err?.message ||
            "Something went wrong",
        },
        {
          success: {
            duration: 3000,
            icon: "📩",
          },
        }
      );
    } catch (err) {
      console.error("Error downloading report:", err);
    } finally {
      setDownloading(false);
    }
};

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "All",
          value: "all",
        },
        {
          label: "Clear",
          value: "clear",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
       ...selectedFleets?.length ? [{
          label: "All",
          value: "all",
        }]: [],
        ...selectedFleets?.length ? [{
          label: "Clear",
          value: "clear",
        }]: [],
        ...(selectedFleets?.includes("all") ? 
        allHubs?.data?.length &&
          allHubs?.data
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            }) : 
        allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  console.log('selectedFleets--',selectedFleets);

  return (
    <div>
      <div>
        <div className="w-full px-8 flex justify-center mt-4 items-center gap-4">
          <label className="w-full ">
            Select Fleets
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: getFleetOptions()?.find(
                      (item) => item?.value === fleet
                    )?.label,
                  };
                })
              }
              onChange={(value) => {
                let allValues = value?.map((item) => item.value);
                if (allValues?.includes("clear")) {
                  // console.log(allValues)
                  setSelectedFleets([]);
                  setSelectedHubs([]);
                  return;
                }
                if (
                  !selectedFleets?.includes("all") &&
                  allValues.includes("all")
                ) {
                  setSelectedFleets(["all"]);
                  return;
                }

                if (selectedFleets.includes("all")) {
                  // console.log("first");
                  // console.log(getFleetOptions())
                  value = value.filter((item) => item.value !== "all");
                }

                let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                  value?.map((item) => item.value)?.includes(fleet._id)
                );

                let selectedHubsVal = allHubs?.data?.filter((hub) =>
                  selectedHubs?.map((item) => item)?.includes(hub._id)
                );

                setSelectedHubs(
                  selectedHubsVal
                    ?.filter((hub) =>
                      selectedFleetsVal?.find(
                        (fleet) => fleet.fleetCode === hub.fleetCode
                      )
                    )
                    .map((hub) => hub._id)
                );

                // console.log({allHubs, selectedHubs})

                setSelectedFleets(value.map((fleet) => fleet.value));
              }}
              name="fleets"
              isMulti={true}
            />
          </label>
          <label className="w-full ">
            Select Hubs
            <ReactSelect
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: "transparent",
                  minWidth: "100%",
                  "&:hover": {
                    borderColor: "rgb(34 197 94)",
                  },
                }),
              }}
              className="shadow-md rounded-md py-1 mb-2"
              options={getHubOptions()}
              value={
                selectedHubs &&
                selectedHubs?.map((hub) => {
                  // console.log({hub})
                  return {
                    value: hub,
                    label: getHubOptions()?.find((item) => item.value === hub)
                      ?.label,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);
                // console.log({allValues})
                if (allValues.includes("clear")) {
                  setSelectedHubs([]);
                  return;
                }
                if (
                  !selectedHubs?.includes("all") &&
                  allValues.includes("all")
                ) {
                  let selectedFleetCodes = allFleets?.data
                    ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                    ?.map((fleet) => fleet.fleetCode);

                  const selectedHubsData = allHubs?.data?.filter((hub) =>
                    selectedFleetCodes?.includes(hub.fleetCode)
                  );

                  const mp = fleetMap;
                  selectedHubsData.map((hub) => {
                    if (selectedFleetCodes?.includes(hub.fleetCode)) {
                      if (mp[hub.fleetCode] === undefined)
                        mp[hub.fleetCode] = [];
                      mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                    }
                  });

                  setFleetMap(mp);
                  setSelectedHubs(["all"]);
                } else {
                  // console.log({value})
                  value = value.filter((value) => value.value !== "all");
                  // console.log({value})
                  let selectedFleetCodes = allFleets?.data
                    ?.filter((fleet) => selectedFleets?.includes(fleet._id))
                    ?.map((fleet) => fleet.fleetCode);
                  // console.log({allValues})

                  const selectedHubsData = allHubs?.data?.filter((hub) =>
                    allValues?.includes(hub._id)
                  );
                  const mp = {};
                  selectedHubsData.map((hub) => {
                    mp[hub.fleetCode] = [];
                  });

                  selectedHubsData.map((hub) => {
                    if (selectedFleetCodes?.includes(hub.fleetCode)) {
                      if (mp[hub.fleetCode] === undefined)
                        mp[hub.fleetCode] = [];
                      mp[hub.fleetCode] = [...mp[hub.fleetCode], hub._id];
                    }
                  });

                  setFleetMap(mp);
                  setSelectedHubs(value.map((hub) => hub.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>
          <label className="w-full ">
            Contract Type
            <ReactSelect
           styles={{
            control: (base, state) => ({
              ...base,
              borderColor: 'transparent',
              minWidth: '100%',
              '&:hover': {
                borderColor: 'rgb(34 197 94)',
              },
            }),
          }}
            name="contractType"
            className="shadow-md rounded-md py-1 mb-2"
            value={contractTypeOptions.find(option => option.value === contractType)}
            onChange={(option) => {
              setContractType(option.value);
            }}
            options={contractTypeOptions}
          />
          </label>
        </div>

        <div className="w-full px-8 flex justify-start mt-2 items-center gap-4">
   
          <label>
            Start Date{" "}
            <Input
              type="date"
              max={getFormattedDate()}
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label>
            End Date{" "}
            <Input
              type="date"
              min={getFormattedDate(dateFrom)}
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label>
          <Button
            type="button"
            disabled={selectedFleets.length == 0 }
            bgPrimary
            onClick={() => getDownloadData()}
        >
            Generate Report
        </Button>
        </div>
      </div>
    </div>
  );
};

export default VehicleFleetReport;